import { render } from "./PopUpCard.vue?vue&type=template&id=6483a471&scoped=true"
import script from "./PopUpCard.vue?vue&type=script&lang=js"
export * from "./PopUpCard.vue?vue&type=script&lang=js"

import "./PopUpCard.vue?vue&type=style&index=0&id=6483a471&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6483a471"]])

export default __exports__